import Icon from '../components/Icon.vue'

Icon.register({
  'shuttle-van': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M628.9 210.7c7.2 8.6 11.1 19.5 11.1 30.7v110.6c0 17.7-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96h-128c0 53-43 96-96 96s-96-43-96-96h-32c-17.7 0-32-14.3-32-32v-288c0-17.7 14.3-32 32-32h425.5c12.4 0 28.9 7.7 36.9 17.3zM64 192h96v-96h-96v96zM160 432c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM320 192v-96h-96v96h96zM480 432c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM384 192h146l-80-96h-66v96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shuttle-van.js
// module id = 1888
// module chunks = 0